<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="container text-center p-0">
                    <h4 class="mb-3 mt-3">{{ 'pricing_start_today' | localise }}</h4>
                    <p class="w-75 mx-auto mb-3">{{ 'pricing_choose_a_plan' | localise }}</p>

                    <ng-container *ngIf="!showBraintree">

                        <ng-container *ngIf="!isYettel()">
                            <div id="yearly-pricing-toggle" *ngIf="masterProfile === false">
                            <span class="monthly"
                                  (click)="onYearlyPricingToggleChange(false)">
                                {{ 'billing_monthly' | localise }}
                            </span>
                                <app-toggle-switch [toggled]="showYearlyPricing"
                                                   (onChange)="onYearlyPricingToggleChange($event)"></app-toggle-switch>
                                <span class="yearly"
                                      (click)="onYearlyPricingToggleChange(true)"
                                      [disableTooltip]="false"
                                      #activeCheck="ngbTooltip"
                                      placement="{{ (isMobile() === false ? 'right' : 'top-right') }}"
                                      tooltipClass="tooltip-warning"
                                      ngbTooltip="{{ 'billing_saving_up_to' | localise }}"
                                >
                                {{ 'billing_yearly' | localise }}
                            </span>
                            </div>

                            <div id="star" *ngIf="influencer">
                                <div
                                        class="card-img-top animated fadeIn influencer-image"
                                        *ngIf="influencer.image"
                                        [lazyLoad]="constants.imagesUrl() + '/images/600x350/' + influencer.image.type + '/' + influencer.image.name + '/'">
                                </div>

                                <div class="influencer-intro-text">
                                    <h2>{{ this.influencer.influencer.name }}</h2>
                                    <p class="duty">{{ this.influencer.influencer.duty }}</p>
                                    <p>
                                        <button class="btn btn-danger remove-star" (click)="removeStar()">
                                            <i class="fa fa-times"></i>
                                            {{ 'dashboard_pricing_remove_from_order' | localise }}
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="isYettel()">
                            <div class="yettel-logo-pricing">
                                <img src="assets/images/yettel-logo.png" height="42" alt="Yettel Logo">
                            </div>
                        </ng-container>

                        <div class="pricing-table">
                            <div *ngFor="let pricing of pricings"
                                 class="stretch-card pricing-card">
                                <div class="card border pricing-card-body p-4 border-primary"
                                     [class.yettel-border]="isYettel()">
                                    <div class="text-center pricing-card-head">
                                        <h3 [class.text-success]="isTrialPlan(pricing)">{{ pricing.title }}</h3>

                                        <ng-container *ngIf="isYettel()">
                                            <h1 class="font-weight-normal">
                                                <span class="yettel-price">{{ '0.00' | money }}</span>
                                                <span class="monthly-text">/ до {{ generateThreeMonthsDate() }}</span>
                                            </h1>
                                            <h2 class="yettel-saved-price">
                                                <del>
                                                    {{ '19.99' | money }}
                                                </del>
                                            </h2>
                                        </ng-container>

                                        <ng-container *ngIf="!isYettel()">

                                            <ng-container *ngIf="showYearlyPricing === true && !isTrialPlan(pricing)">
                                                <h1 class="font-weight-normal mt-3 text-success">
                                                    {{ getLanguagePricingAmount(pricing).yearly_price | money }}
                                                    <span class="monthly-text">/ {{ 'yearly' | localise }}</span>
                                                </h1>
                                            </ng-container>

                                            <ng-container *ngIf="showYearlyPricing === true && isTrialPlan(pricing)">
                                                <h1 class="font-weight-normal mt-3">
                                                    {{ '0.00' | money }}
                                                    <span class="monthly-text">/ {{ 'yearly' | localise }}</span>
                                                </h1>
                                            </ng-container>

                                            <ng-container *ngIf="showYearlyPricing === false">
                                                <div *ngIf="!isTrialPlan(pricing)">
                                                    <ng-container *ngIf="!discountCode">
                                                        <h1 class="font-weight-normal"
                                                            *ngIf="currentUserIsReferral === false || (currentUserIsReferral === true && getLanguagePricingAmount(pricing).discount_monthly_price.length === 0)">
                                                            {{ getLanguagePricingAmount(pricing).monthly_price | money }}
                                                            <span class="monthly-text">/ {{ 'monthly' | localise }}</span>
                                                        </h1>

                                                        <h1 class="font-weight-normal"
                                                            *ngIf="getLanguagePricingAmount(pricing).discount_monthly_price.length > 0 && currentUserIsReferral === true">
                                                            {{ getLanguagePricingAmount(pricing).discount_monthly_price | money }}
                                                            <span class="monthly-text">/ {{ 'monthly' | localise }}</span>
                                                        </h1>

                                                        <h1 class="font-weight-normal"
                                                            *ngIf="getLanguagePricingAmount(pricing).discount_monthly_price.length > 0 && currentUserIsReferral === true">
                                                            <del style="color: #e81616; font-size: 1.3rem;">{{ getLanguagePricingAmount(pricing).monthly_price | money }}</del>
                                                            <span class="monthly-text">/ {{ 'monthly' | localise }}</span>
                                                        </h1>
                                                    </ng-container>

                                                    <ng-container *ngIf="discountCode">
                                                        <h1 class="font-weight-normal">
                                                            <span style="color: #0e900e;">{{ getLanguagePricingAmount(pricing).monthly_price | money }}</span>
                                                            <span class="monthly-text">/ {{ 'monthly' | localise }}</span>
                                                        </h1>
                                                    </ng-container>
                                                </div>

                                                <div *ngIf="isTrialPlan(pricing)">
                                                    <h1 class="font-weight-normal">
                                                        {{ '0.00' | money }}
                                                        <span class="monthly-text">/ {{ 'first_month' | localise }}</span>
                                                    </h1>
                                                </div>
                                            </ng-container>

                                        </ng-container>

                                    </div>

                                    <ul class="list-unstyled plan-features"
                                        [class.yettel-plan-features]="isYettel()">
                                        <li *ngFor="let feature of pricing.features">
                                            <i class="fa fa-check-circle"></i>
                                            {{ feature.title }}
                                        </li>

                                        <ng-container *ngIf="isTrialPlan(pricing) && influencer">
                                            <li>
                                                <i class="fa fa-times-circle text-danger"></i>
                                                {{ 'dashboard_pricing_without_recipes_of' | localise }} <strong>{{ influencer.influencer.name }}</strong>
                                            </li>
                                        </ng-container>

                                        <ng-container *ngIf="!isTrialPlan(pricing) && influencer">
                                            <li>
                                                <i class="fa fa-check-circle"></i>
                                                {{ 'dashboard_pricing_with_recipes_of' | localise }} <strong>{{ influencer.influencer.name }}</strong>
                                            </li>
                                        </ng-container>
                                    </ul>

                                    <div class="pricing-buttons wrapper">
                                        <ng-container *ngIf="isYettel()">
                                            <button
                                                    class="btn btn-block btn-primary yettel-button-subscribe"
                                                    (click)="onChooseYettel()"
                                            >
                                                {{ ('choose' | localise) }}
                                            </button>

                                            <div class="yettel-notice">
                                                <p>Потребителите на Yettel се възползват от безплатен план до {{ generateThreeMonthsDate() }}г.</p>
                                                <p>След този период потребителя ще може да избере платен план и да продължи да изпозлва Agaia.</p>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="!isYettel()">
                                            <button
                                                    class="btn btn-block"
                                                    [class.btn-primary]="!isTrialPlan(pricing)"
                                                    [class.btn-success]="isTrialPlan(pricing)"
                                                    (click)="onChoose(pricing)"
                                            >
                                                {{ isTrialPlan(pricing) ? ('pricing_start_now' | localise) : ('choose' | localise) }}
                                            </button>

                                            <ng-container *ngIf="showYearlyPricing === false && !influencer">
                                                <button
                                                        *ngIf="!isTrialPlan(pricing) && !discountCode"
                                                        class="btn btn-block btn-outline-info"
                                                        (click)="applyDiscountCode()"
                                                >
                                                    {{ 'discount_code' | localise }}
                                                </button>
                                                <button
                                                        *ngIf="!isTrialPlan(pricing) && discountCode"
                                                        class="btn btn-block btn-outline-light"
                                                        (click)="applyDiscountCode()"
                                                >
                                                    {{ 'code' | localise }} {{ discountCode.code }}
                                                </button>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showBraintree">
                        <div id="dropin-container"></div>

                        <button class="btn btn-secondary" id="back-button" (click)="back()" style="margin-right: 10px">
                            {{ 'back' | localise }}
                        </button>

                        <button class="btn btn-primary" id="submit-button" (click)="requestPaymentMethod()">
                            {{ 'subscribe' | localise }}
                        </button>

                        <br/><br/>

                        <app-alerts-components
                                [disableClose]="true"
                                [type]="'info'"
                                [icon]="'ti-help-alt'"
                                [id]="'payment_info'"
                                [title]="'subscription_info_title' | localise"
                                [message]="'subscription_info' | localise"></app-alerts-components>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
